import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { Stack, Box } from '@mui/material';
import Empty from 'components/empty';
import announcementStyle from 'pages/announcements/style';

const AnnouncementList = React.lazy(() => import('pages/announcements/AnnouncementList'));

const AnnouncementsPage = () => (
    <>
        <Helmet>
            <title>Announcements - DevX Infra</title>
        </Helmet>
        <Suspense
            fallback={
                <Stack sx={announcementStyle?.loadingStack}>
                    <Empty color="#000000" isLoading />
                </Stack>
            }
        >
            <Box className="contentContainer" sx={announcementStyle?.wrapper} data-testid="announcements-page">
                <AnnouncementList />
            </Box>
        </Suspense>
    </>
);

export default AnnouncementsPage;
